import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { AnimatePresence } from "framer-motion";

import FnrLoadingBricks from "UI/FnrLoadingBricks";

import { isTouchDevice } from "Utilities/isTouchDevice";

HoverButton.propTypes = {
  isHovering: PropTypes.bool,
  onClick: PropTypes.func,
  icon: PropTypes.object,
  isLoading: PropTypes.bool,
  isActive: PropTypes.bool,
};

export default function HoverButton({
  isHovering,
  onClick,
  icon,
  isLoading,
  isActive,
}) {
  const shouldDisplay = isHovering || isTouchDevice();

  return (
    <Wrapper>
      <AnimatePresence>
        {isLoading ? (
          <FnrLoadingBricks show size={16} />
        ) : shouldDisplay ? (
          <Button
            role="button"
            onClick={onClick}
            forceShowHoverStyles={isActive}
          >
            <FontAwesomeIcon icon={icon} />
          </Button>
        ) : null}
      </AnimatePresence>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin: 0 1px;
`;

const Button = styled.div`
  height: 17px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1px 4px;
  font-size: 13px;
  border-radius: 4px;
  color: #a5a5a5;
  cursor: pointer;
  background: ${({ forceShowHoverStyles }) =>
    forceShowHoverStyles ? "#d9dbe5" : "none"};
  transition: background 150ms;

  &:hover {
    background: #d9dbe5;
  }

  &:active {
    transform: scale(0.94);
  }
`;
